import React, { useState } from 'react';
import { Box } from '@mui/material';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';

const DashboardLayout: React.FC = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);  // To control sidebar visibility

  const toggleSidebar = () => {
    setIsCollapsed(prev => !prev);  // Toggle the sidebar state
  };

  return (
    <Box sx={{ display: 'flex',  }}>
      {/* Sidebar Component */}
      <Sidebar
        isCollapsed={isCollapsed}
        sx={{
          transition: 'transform 0.3s ease-in-out',
          transform: isCollapsed ? 'scale(0)' : 'scale(1)',  // Zoom-in effect
        
        }}
      />
      
      {/* Main content area */}
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Navbar toggleSidebar={toggleSidebar} />
        <Box component="main" sx={{ flexGrow: 1, marginTop: 0 ,marginLeft:1,marginRight:1,marginBottom:1}}>
          <Outlet  />
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
